import React from "react"
import DynamicComponent from "components/DynamicComponent"
import Seo from "src/utils/seo"

const Page = ({ blok }) => {
  const content =
    blok?.content?.body &&
    blok?.content?.body.map(childBlok => <DynamicComponent blok={childBlok} key={childBlok._uid}/>)
  return (
    <div>
        <Seo pageName={blok?.name} pageMeta={blok?.content?.meta} pageNoIndex={blok?.content?.no_index} meta_image={blok?.content?.image} featured_image={blok?.content?.featured_image}/>
        {content}
    </div>
  )
}

export default Page
